import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router'

import { yupResolver } from '@hookform/resolvers/yup'
import { SignupPageStatus } from '@ui/interfaces'
import { useAuth } from '@ui/providers/AuthProvider'
import cx from 'clsx'
import * as Yup from 'yup'

import { UpdatePageStatus } from '../Login'

type LoginFormProps = {
  setPageStatus: UpdatePageStatus
}

export function InvitedForm(props: LoginFormProps) {
  const { setPageStatus } = props
  const navigate = useNavigate()
  const auth = useAuth()

  const { token } = useParams()

  const [waiting, setWaiting] = useState(false)

  const schema = Yup.object({
    password: Yup.string()
      .min(8, 'Password is too short - should be 8 characters minimum.')
      .required('Please enter your password'),
    passwordConfirmation: Yup.string()
      .test('passwords-match', 'Passwords must match', function (value) {
        return this.parent.password === value
      })
      .required(),
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const sendToServer = ({ password, passwordConfirmation }: { password: string; passwordConfirmation: string }) => {
    if (!token) {
      console.error('no token found')
      return
    }

    setWaiting(false)
    auth.invited(password, passwordConfirmation, token, (error: any) => {
      setWaiting(false)

      if (error) {
        const { response } = error
        // Error is an object with key and value as strings.

        if (response && response.status === 422 && response.data.errors) {
          const { errors } = response.data
          const stringifiedError = Object.keys(errors)
            .map((key) => `${key} ${errors[key]}`)
            .join(', ')

          setError('password', { message: stringifiedError })
        } else {
          // For non-validation errors (e.g., 500 Internal Server Error), you can set a global error
          // This could be a state in your component to show the error message
          setPageStatus(SignupPageStatus.FAIL) // Or any other way you handle global errors
        }
      } else {
        setPageStatus(SignupPageStatus.SUCCESS, () => {
          setTimeout(() => {
            navigate('/')
          }, 2000)
        })
      }
    })
  }
  return (
    <div className={'h-fit w-full py-10'}>
      Welcome in!
      <form onSubmit={handleSubmit(sendToServer)} className="text-left">
        Set your password
        <div>
          <label htmlFor="password" className="text-sm text-gray-700">
            Password
          </label>
          <input
            {...register('password')}
            type="password"
            name="password"
            id="password"
            className="mt-2 block w-full rounded-md border-0 bg-gray-100 text-gray-600 shadow-sm outline-none ring-1 ring-inset ring-gray-300 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
          />
          {errors.password && <p className="mt-2 text-xs italic text-red-500">{errors.password?.message}</p>}
        </div>
        <div>
          <label htmlFor="passwordConfirmation" className="text-sm text-gray-700">
            Confirm password
          </label>
          <input
            {...register('passwordConfirmation')}
            type="password"
            name="passwordConfirmation"
            id="passwordConfirmation"
            className="mt-2 block w-full rounded-md border-0 bg-gray-100 text-gray-600 shadow-sm outline-none ring-1 ring-inset ring-gray-300 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
          />
          {errors.passwordConfirmation && (
            <p className="mt-2 text-xs italic text-red-500">{errors.passwordConfirmation?.message}</p>
          )}
        </div>
        <button
          type="submit"
          disabled={waiting}
          className={cx(
            waiting ? 'bg-primary-100' : 'bg-primary-500',
            'mt-8 w-full rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm transition-colors duration-300 ease-in-out hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600'
          )}>
          {waiting ? 'Sending...' : 'Set password'}
        </button>
      </form>
    </div>
  )
}
